let menu;
function showHideMenu(show = false) {
    hold_scroll_page(show);
    if (typeof menu == 'undefined') menu = $("#menu");
    if (show) menu.show(0);
    hideScrollBar(show)
    animateFromTo(menu.find(".menuBG"), animTime / 1000 * 2, { opacity: show ? 0 : 1 }, { opacity: show ? 1 : 0, ease },
        show ? 0 : animTime / 1000 / 2)
    animateFromTo(menu.find(".menuBlock"), animTime / 1000 * 2, { x: show ? "-100%" : "0%" }, {
        x: show ? "0%" : "-100%", ease: Power2.easeOut,
        onComplete: () => {
            if (!show) menu.hide(0);
        }
    }, show ? animTime / 1000 / 2 : 0);
};